import PropTypes from "prop-types"
import { connect } from "react-redux"

import { trackSlide } from "areas/product/store/actions"
import { openModal } from "components/modal"
import Button from "components/ui/button"
import Image from "components/ui/image"

const InternalImageUploadBtn = ({
  handwritingEngraving,
  imageUploaded,
  openImageUploadModal,
}) => {
  const imgText = handwritingEngraving ? "Image" : "Photo"
  return (
    <div className="text-center">
      <Button
        className="px-30 tablet:font-light items-baseline rounded-3xl py-12 font-bold"
        data-cy="product-image-wizard-option-btn"
        onClick={() => openImageUploadModal()}
        variant="secondary"
      >
        <Image
          alt={imageUploaded ? `Change ${imgText}` : `Upload ${imgText}`}
          className="mr-8"
          height="512"
          src={require("images/icons/upload-arrow.svg")}
          style={{ width: "14px" }}
          width="512"
        />
        {imageUploaded ? `Change ${imgText}` : `Upload ${imgText}`}
      </Button>
      <p
        className="text-12 leading-14 mx-auto mt-12 font-bold tracking-tight"
        style={{ maxWidth: "240px" }}
      >
        Photo or image uploads that include inappropriate, explicit, or illegal
        content will not be accepted.
      </p>
    </div>
  )
}

InternalImageUploadBtn.propTypes = {
  handwritingEngraving: PropTypes.bool,
  imageUploaded: PropTypes.bool,
  openImageUploadModal: PropTypes.func,
}

const mapStateToProps = (state, ownProps) => {
  const pref = ownProps.pref || "img1"
  return {
    handwritingEngraving: state.wizard.data[pref]?.handwriting_engraving,
    image: state.display[pref],
    imageUploaded: state.choices[pref] && state.choices[pref].photoUploaded,
    wizardData: state.wizard.data,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const { wizardData } = stateProps
  const { dispatch } = dispatchProps
  return {
    ...ownProps,
    ...stateProps,
    ...dispatchProps,
    openImageUploadModal: () => {
      const pref = ownProps.pref || "img1"
      const iwo = wizardData[pref]
      if (iwo?.track_slide) {
        dispatch(trackSlide(iwo.track_slide))
      }
      openModal(`#pendant-upload-${pref}`)
    },
  }
}

const ImageUploadBtn = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(InternalImageUploadBtn)

export default ImageUploadBtn
